<template>
    <v-card
      elevation="5"          
      class="pl-10 pr-10"
    >
      <v-card-title class="justify-center">{{title}}</v-card-title>
      <v-card-text>
         <v-row no-gutters>
          <v-col cols="12">
            <h4 class="text-left"> 
                <p v-for="(line,index) in textLines" :key="index" class="body-1">
                  <span v-html="line"></span>
                </p>                                    
            </h4>
          </v-col>
        </v-row>
      </v-card-text>        
    </v-card>        
</template>

<script>

  export default {
    name: 'FinalCard',
    props:["block","title"],
    data: () => ({
         results: {}
    }),
    async mounted(){
      
    },
    methods:{
    },
    computed:{
      textLines(){
        return this.block.text[this.selectedGender]
      },
       selectedGender(){
        let genderId = this.$store.state.genderId
        if(genderId == 1)
            return 'female' 
        else if (genderId == 2)
            return 'male'
      }
    }
  }
</script>
